/** YouTube video id from a watch, live, shorts, embed, or youtu.be URL. */
export function youtubeVideoId(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const host = parsed.hostname.replace(/^www\./, '');
  const idPattern = /^[\w-]{11}$/;

  if (host === 'youtu.be') {
    const id = parsed.pathname.split('/').filter(Boolean)[0];
    return id && idPattern.test(id) ? id : null;
  }

  if (host !== 'youtube.com' && host !== 'm.youtube.com' && host !== 'youtube-nocookie.com') {
    return null;
  }

  const fromQuery = parsed.searchParams.get('v');
  if (fromQuery && idPattern.test(fromQuery)) return fromQuery;

  const parts = parsed.pathname.split('/').filter(Boolean);
  const marker = parts.findIndex((part) => part === 'embed' || part === 'live' || part === 'shorts' || part === 'v');
  const id = marker >= 0 ? parts[marker + 1] : undefined;
  return id && idPattern.test(id) ? id : null;
}
